// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mk7fK","label":"styles_label__2Jvhg"};